
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/login",
      function () {
        return require("private-next-pages/[locale]/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/login"])
      });
    }
  